<template>
    <v-container :class="{'pa-0' : $vuetify.breakpoint.xsOnly}" class="ma-0 px-0" style="max-width: 100%;" id="body-wrapper">
        <!--Entête de section-->
        <v-layout row class="hospital-tileable" fill-height>
            <v-flex class="hospital">
                <v-layout
                    row
                    wrap
                    fill-height
                    align-center
                    justify-end>
                    <v-flex xs12 sm7>
                        <v-layout justify-end :mt-4="$vuetify.breakpoint.xsOnly">
                            <v-flex
                                class="bubble"
                                xs12
                                sm10
                                md7
                                pa-6>
                                <div class="headline">
                                    {{ $t('notFound.title') }}
                                </div>
                                <div class="subheading my-4">
                                    {{ $t('notFound.content1') }}
                                </div>
                                <div class="subheading my-4">
                                    {{ $t('notFound.content2') }}
                                </div>
                                <div class="subheading my-4">
                                    {{ $t('notFound.thanks') }}
                                </div>
                                <div class="text-center">
                                    <v-btn color="primary" :href="getPortalLink()">
                                        {{ $t("notFound.linkToPortal") }}
                                    </v-btn>
                                </div>
                            </v-flex>
                        </v-layout>
                    </v-flex>

                    <v-flex xs12 sm5 class="nurse" />
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { inferPortalUrl } from '@/helpers/env';

export default {
    name: 'not-found',
    methods: {
        getPortalLink() {
            return inferPortalUrl();
        },
    },
};
</script>

<style lang="scss" scoped>
    .hospital-tileable {
        background: transparent url("/img/404_hospital_tileable.png") center center;
        background-size: 100% 425px;
    }
    .hospital {
        width: 100%;
        min-height: 425px;
        background: transparent url("/img/404_hospital_background.png") center center no-repeat;
    }
    .nurse {
        min-height: 425px;
        background: transparent url("/img/404_character.png") center left no-repeat;
    }
    .bubble {
        border-radius: 10px;
        background: rgba(255, 255, 255, 0.8);
        height: 300px;
    }

    @media only screen and (max-width: 600px) {
        .nurse {
            min-height: 325px;
            background: transparent url("/img/404_character.png") center center no-repeat;
            background-size: contain;
        }

        .hospital-tileable {
            background: none;
        }

        .hospital {
            min-height: 325px;
            background: transparent url("/img/404_hospital_background.png") bottom center no-repeat;
        }
    }
</style>
